<tui-root [attr.tuiTheme]="theme.current()">
  <router-outlet />
</tui-root>
